var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
// tslint:disable:max-line-length
// This file is generated by generateStyles script.
// Please don't edit it manually.
import * as React from "react";
import "../../less/svg/ScrollArrowRight.less";
export var ScrollArrowRight = function (props) { return (React.createElement("svg", { viewBox: "0 0 34.91 60.13" },
    React.createElement("defs", null),
    React.createElement("g", __assign({ id: "Layer_2" }, props, { className: "ScrollArrowRight " + props.className }),
        React.createElement("g", { id: "Leagues" },
            React.createElement("g", { id: "Info_and_rewards", "data-name": "Info and rewards" },
                React.createElement("g", { id: "ScrollArrowRight" },
                    React.createElement("path", { className: "cls-1", d: "M5.73 60.13A5.73 5.73 0 0 1 0 54.41V5.72A5.71 5.71 0 0 1 9.67 1.6L31.9 23a9.8 9.8 0 0 1 0 14.13L9.67 58.52a5.65 5.65 0 0 1-3.94 1.61z" }),
                    React.createElement("path", { className: "cls-2", d: "M8.11 3.22l22.23 21.4a7.56 7.56 0 0 1 0 10.89L8.11 56.9a3.46 3.46 0 0 1-5.86-2.49V5.72a3.46 3.46 0 0 1 5.86-2.5z" }),
                    React.createElement("path", { className: "cls-3", d: "M24.13 30.06L11.26 49.54l19.08-14a7.56 7.56 0 0 0 0-10.89l-19.08-14z" }),
                    React.createElement("path", { className: "cls-4", d: "M5.73 5.25a.42.42 0 0 1 .3.14l22.23 21.39a4.54 4.54 0 0 1 0 6.56L6 54.74a.42.42 0 0 1-.3.14s-.48 0-.48-.47V5.72a.48.48 0 0 1 .48-.47m0-3a3.46 3.46 0 0 0-3.45 3.47v48.69a3.46 3.46 0 0 0 3.48 3.47 3.42 3.42 0 0 0 2.38-1l22.23-21.37a7.56 7.56 0 0 0 0-10.89L8.11 3.22a3.41 3.41 0 0 0-2.38-1z" }))))))); };



//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/ScrollArrowRight.tsx
// module id = 2785
// module chunks = 3